<template>
  <el-card shadow="never">
    <pdf
      ref="pdf"
      :src="source"
      :page="page"
      @num-pages="totalPages = $event"
      @link-clicked="page = $event"
    >
    </pdf>
  </el-card>
</template>

<script>
import pdf from 'vue-pdf';

export default {
  name: 'PreviewPdf',
  components: { pdf },
  props: {
    source: { type: String, required: true },
  },
  data() {
    return {
      totalPages: 0,
      page: 1,
      loading: false,
    };
  },
}
</script>



// WEBPACK FOOTER //
// src/components/PreviewPdf.vue